export default __webpack_public_path__ + "static/media/Shoe-2.f4dcdf94.mp4";